<div class="download-dialog">
    <div class="download-header-container">
        <span class="download-header-text">DOWNLOAD ORDER REPORT</span>
    </div>
    <div class="download-sub-header-container">
        <p  class="download-sub-head-text">Which filters would you like to apply</p>
    </div>

    <form [formGroup]="reportForm" class="download-box">
        <mat-form-field appearance="outline">
            <mat-label>Start date</mat-label>
            <input matInput formControlName="from" [matDatepicker]="pickerStart"  placeholder="Start" (dateInput)="setFilterStartDate($event)">           
            <mat-datepicker-toggle matIconSuffix [for]="pickerStart" ></mat-datepicker-toggle>
            <mat-datepicker #pickerStart></mat-datepicker>
        </mat-form-field>

        <mat-form-field appearance="outline">
            <mat-label>End date</mat-label>
            <input matInput  formControlName="to" [matDatepicker]="pickerEnd"   placeholder="End date" (dateInput)="setFilterEndDate($event)">
            <mat-datepicker-toggle matIconSuffix [for]="pickerEnd"></mat-datepicker-toggle>
            <mat-datepicker #pickerEnd></mat-datepicker>
        </mat-form-field>

        <mat-form-field appearance="outline">
            <mat-label appRemoveAriaOwns>Select Status</mat-label>
            <mat-select formControlName="status">
                <mat-option style="background-color: white!important; padding: 6px!important;">
                    <div class="select-search-container-sm">
                        <div class="select-search-sm">
                            <ngx-mat-select-search placeholderLabel="Search Status" [formControl]="statusFilterCtrl">
                                <span ngxMatSelectNoEntriesFound>
                                    No entries found
                                </span>
                            </ngx-mat-select-search>
                        </div>
                    </div>
                </mat-option>
                <mat-option *ngFor="let status of filteredStatusList" [value]="status.id">
                    {{status.description}}
                </mat-option>
            </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" *ngIf="otcRole !== 'agent'">
            <mat-label appRemoveAriaOwns>Select Agent</mat-label>
            <mat-select formControlName="agent">
                <mat-option style="background-color: white!important; padding: 6px!important;">
                    <div class="select-search-container-sm">
                        <div class="select-search-sm">
                            <ngx-mat-select-search placeholderLabel="Search Agents" [formControl]="agentFilterCtrl">
                                <span ngxMatSelectNoEntriesFound>
                                    No entries found
                                </span>
                            </ngx-mat-select-search>
                        </div>
                    </div>
                </mat-option>
                <mat-option *ngFor="let agent of filterAgentList" [value]="agent.id">
                    {{agent?.user?.name}} {{agent?.user?.surname}}
                </mat-option>
            </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" *ngIf="otcRole !== 'agent' && otcRole !== 'rep'">
            <mat-label appRemoveAriaOwns>Select 'Created By User'</mat-label>
            <mat-select formControlName="createdByUser">
                <mat-option style="background-color: white!important; padding: 6px!important;">
                    <div class="select-search-container-sm">
                        <div class="select-search-sm">
                            <ngx-mat-select-search placeholderLabel="Search User" [formControl]="createdByFilterCtrl">
                                <span ngxMatSelectNoEntriesFound>
                                    No entries found
                                </span>
                            </ngx-mat-select-search>
                        </div>
                    </div>
                </mat-option>
                <mat-option *ngFor="let user of filterCreatedByList" [value]="user.id">
                    {{user?.name}} {{user?.surname}}
                </mat-option>
            </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline">
            <mat-label appRemoveAriaOwns>Select Plant</mat-label>
            <mat-select formControlName="plnt">
                <mat-option style="background-color: white!important; padding: 6px!important;">
                    <div class="select-search-container-sm">
                        <div class="select-search-sm">
                            <ngx-mat-select-search placeholderLabel="Search Plants" [formControl]="plantFilterCtrl">
                                <span ngxMatSelectNoEntriesFound>
                                    No entries found
                                </span>
                            </ngx-mat-select-search>
                        </div>
                    </div>
                </mat-option>
                <mat-option *ngFor="let plant of filteredPlantList" [value]="plant.id">
                    {{plant?.plantCode}} - {{plant?.name}}
                </mat-option>
            </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline">
            <mat-label appRemoveAriaOwns>Select Payment Terms</mat-label>
            <mat-select formControlName="payT">
                <mat-option style="background-color: white!important; padding: 6px!important;">
                    <div class="select-search-container-sm">
                        <div class="select-search-sm">
                            <ngx-mat-select-search placeholderLabel="Search Terms" [formControl]="termsFilterCtrl">
                                <span ngxMatSelectNoEntriesFound>
                                    No entries found
                                </span>
                            </ngx-mat-select-search>
                        </div>
                    </div>
                </mat-option>
                <mat-option *ngFor="let term of filteredTermsList" [value]="term.id">
                    {{term.description}}
                </mat-option>
            </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline">
            <mat-label>KB / Customer PO</mat-label>
            <input matInput formControlName="kbnum">
        </mat-form-field>

        <mat-form-field appearance="outline">
            <mat-label>Sold-to</mat-label>
            <input matInput formControlName="soldTo">
        </mat-form-field>

        <mat-form-field appearance="outline">
            <mat-label>Sold-to Description</mat-label>
            <input matInput formControlName="soldToDesc">
        </mat-form-field>

        <mat-form-field appearance="outline">
            <mat-label>Payer</mat-label>
            <input matInput formControlName="payer">
        </mat-form-field>

        <mat-form-field appearance="outline">
            <mat-label>Payer Description</mat-label>
            <input matInput formControlName="payerDesc">
        </mat-form-field>

        <mat-form-field appearance="outline">
            <mat-label>Material Description</mat-label>
            <input matInput formControlName="materialDesc">
        </mat-form-field>

        <mat-form-field appearance="outline">
            <mat-label>Co-op / Customer Order No</mat-label>
            <input matInput formControlName="coOpNo">
        </mat-form-field>
    </form>

    <div class="download-dialog-button-container">
        <button class="cancel-download-btn" mat-flat-button type="button" (click)="closeDialog(false)">
            <div class="cancel-download-content">
                <span><p class="cancel-download-text">Cancel</p></span>
            </div>
        </button>

        <button class="apply-download-btn" mat-flat-button type="button" (click)="closeDialog(true)">
            <div class="apply-download-content">
                <span><p class="apply-download-text">Apply</p></span>
            </div>
        </button>
    </div>
</div>